import { AngularSvgIconModule } from 'angular-svg-icon';
import { BrowserModule } from '@angular/platform-browser';
import { CustomComponentModule, LoginFormComponent } from '../../components';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Erfolg1SvgComponent } from '@ebeihilfe/web-shared/web-svgs/erfolg-1/erfolg-1.component';
import { Erfolg2SvgComponent } from '@ebeihilfe/web-shared/web-svgs/erfolg-2/erfolg-2.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { NoteComponent } from '@ebeihilfe/web-shared/note';
import { PasswordInputComponent } from '@ebeihilfe/web-shared/password-input';
import { ProgressBarComponent } from '@ebeihilfe/web-shared/progress-bar';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RouterModule } from '@angular/router';
import { StartPageComponent } from './start-page/start-page.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    AngularSvgIconModule,
    BrowserModule,
    CustomComponentModule,
    Erfolg1SvgComponent,
    Erfolg2SvgComponent,
    FormsModule,
    LoginFormComponent,
    MatButtonModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    NoteComponent,
    PasswordInputComponent,
    ProgressBarComponent,
    ReactiveFormsModule,
    RouterModule,
    StartPageComponent,
    TranslateModule.forChild(),
    DashboardComponent,
  ],
  exports: [RouterModule],
  declarations: [LoginComponent, ResetPasswordComponent],
})
export class AppPagesModule {}
